import { Controller } from "@hotwired/stimulus"

export default class ActivityCommentsController extends Controller {
  static targets = ["commentField", "submitButton"]

  enableSubmit() {
    if (this.commentFieldTarget.value.trim().length > 0) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.add("bg-indigo-600", "hover:bg-indigo-500", "focus:outline-none", "focus:border-indigo-700", "focus:shadow-outline-indigo", "active:bg-indigo-700")
      this.submitButtonTarget.classList.remove("bg-gray-400")
    }
    else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.remove("bg-indigo-600", "hover:bg-indigo-500", "focus:outline-none", "focus:border-indigo-700", "focus:shadow-outline-indigo", "active:bg-indigo-700")
      this.submitButtonTarget.classList.add("bg-gray-400")
    }
  }
}
